import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdbreact';
import { withRouter } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import TablePagination from "@material-ui/core/TablePagination";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import BasicButton from '../../components/SharedComponents/BasicButton/BasicButton';
import TableComponent from '../../components/SharedComponents/Table';
import ModalComponent from '../../Common/DefaultModalLayout/Modal/Modal';
import { handlePaginationList } from "../../Common/TableHelper";
import { representativeAnimationList } from '../../../constants/NavList';
import { withUserContext } from '../../../contexts/UserContext';
import CasterService from '../../../services/service';
import * as Constants from '../../../constants/constants';
import { searchRepresentativeConfig, repFilterJson, repSortByConfig } from './Config';
import SearchFilters from './SearchFilters';
import './Search.scss';

class SearchRepresentativeContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            config: searchRepresentativeConfig,
            filterValues: JSON.parse(JSON.stringify({ ...repFilterJson })),
            rowsPerPage: 10,
            page: 0,
            sortBy: "Date Created",
            isSortByAsc: false,
            sortCount: 0,
            repFilters: [],
            clearFilter: false,
            selectedSort: {
                value: 1,
                label: 'Date Created',
                sortBy: 'Date Created'
            },
            sortOrder: 'DESC',
            openRepresentativeModal: false,
            openNewRepresentativeModal: false,
            selectedRepId: null,
        }
    }

    componentDidMount() {
        this.getRepDetails();
        this.getLookupData('COMPANY_TYPE', 'companyTypeOptions')
        this.getLookupData('REP_TYPE', 'repTypeOptions')
    }

    getRepDetails = () => {
        this.setState({ isFetchingRepList: true })
        let payload = { ...this.state.filterValues };
        payload['order_by_clause'] = this.state.selectedSort?.sortBy;
        payload['order_by'] = this.state.isSortByAsc === true ? 'ASC' : 'DESC';
        payload['page_count'] = this.state.rowsPerPage;
        payload['page_no'] = this.state.page + 1;
        CasterService.getData(Constants.CasterServiceBaseUrl +
            `/animationGetSearchRepresentative?input=${btoa(JSON.stringify(payload))}`,
            this.props.userContext.active_tenant.tenant_id, 1)
            .then(response => {
                let tableData = response?.data?.records || [];
                this.setState({
                    list: handlePaginationList(0, this.state.rowsPerPage, tableData),
                    isFetchingRepList: false,
                    repCount: response?.data?.query_record_count
                })
            },
                (err) => {
                    console.log("Error in fetching performers:", err)
                    this.setState({ isFetchingRepList: false })
                })
    }

    getLookupData = (entity, optionName) => {
        CasterService.getData(Constants.CasterServiceBaseUrl + `/animationGetLookupData?entityType=${entity}`,
            this.props?.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response.data;
                if (entity === 'COMPANY_TYPE' || entity === 'REP_TYPE') {
                    formattedList = formattedList?.map(item => ({ value: item.lookup_data_id, label: item.lookup_value, is_active: item.is_active }));
                } else {
                    formattedList = formattedList?.map(item => ({ value: item.lookup_data_id, text: item.lookup_value, is_active: item.is_active }));
                }
                this.setState({ [optionName]: formattedList })
            },
                (err) => {
                    console.log('Error is fetching details' + err);
                });
    }

    getEntitySearch = (entity, optionName, searchString = null, showId = null) => {
        let url = `/animationGetEntitySearch?entity=${entity}&searchString=${searchString}`
        CasterService.getData(Constants.CasterServiceBaseUrl + url,
            this.props?.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response.data
                if (entity === 'COMPANY') {
                    formattedList = formattedList?.map(item => ({ value: item.company_id, text: item.company_name }));
                } else if (entity === 'TALENT') {
                    formattedList = formattedList?.map(item => ({ value: item.talent_id, text: item.talent_name }));
                }
                this.setState({ [optionName]: formattedList })
            },
                (err) => {
                    console.log('Error is fetching details' + err);
                });
    }

    handleFilterOnChange = (filterField, filterName, value) => {
        let repTypeName = this.state.repTypeOptions?.find(item => item.value === value)?.label;
        let companyTypeName = this.state.companyTypeOptions?.find(item => item.value === value)?.label;
        let talentName = this.state.coveredTalentOptions?.find(item => item.value === value)?.text;
        this.setState((prevState) => ({
            filterValues: {
                ...prevState.filterValues,
                [filterField]: filterField === 'representative_type' ? repTypeName :
                    filterField === 'company_type' ? companyTypeName : value,
            },
        }), () => {
            let repFilters = [...this.state.repFilters];
            let filteredRep = repFilters?.find(item => item.filter === filterField);
            let filterValue = {};
            filterValue['filter'] = filterField;
            if (filteredRep) {
                repFilters?.map(item => {
                    if (item?.filter === filterField) {
                        item.value = filterField === 'representative_type' ? (filterName + ': ' + repTypeName) :
                            filterField === 'company_type' ? (filterName + ': ' + companyTypeName) :
                                filterField === 'talent_id' ? (filterName + ': ' + talentName) :
                                    filterName + ': ' + value;
                    }
                    return item;
                })
            } else {
                filterValue['value'] = filterField === 'representative_type' ? (filterName + ': ' + repTypeName) :
                    filterField === 'company_type' ? (filterName + ': ' + companyTypeName) :
                        filterField === 'talent_id' ? (filterName + ': ' + talentName) :
                            filterName + ': ' + value;
            }
            if (filterValue?.value) {
                repFilters?.push(filterValue);
            }
            this.setState({ repFilters: repFilters })
            this.getRepDetails();
        })
    }

    handleFilterDelete = (filterIndex, filter) => {
        let repFilters = [...this.state.repFilters];
        repFilters = repFilters.filter(function (item) {
            return item?.filter !== filter
        })
        let filterValues = { ...this.state.filterValues }
        filterValues[filter] = null;
        this.setState({
            repFilters: repFilters,
            filterValues: filterValues,
            deletedFilter: filter
        }, () => {
            this.getRepDetails();
        })
    }

    handleClearCriteria = () => {
        this.setState({
            repFilters: [],
            filterValues: JSON.parse(JSON.stringify({ ...repFilterJson })),
            clearFilter: true
        }, () => {
            this.getRepDetails()
        })
    }
    
    handleSetClearFilter = () => {
        this.setState({ clearFilter: false })
    }

    functions = {
        handleHideRepPopup: () => {
            this.setState({ openRepresentativeModal: false });
        }
    }

    setJson = (field, value) => {
        switch (field) {
            case 'pagePerRow':
                this.setState({ rowsPerPage: value, page: 0 }, () => {
                    this.getRepDetails();
                });
                break;
            case 'page':
                this.setState({ page: value }, () => {
                    this.getRepDetails();
                });
                break;
        }
    }


    navigationCallback = (dataItem, node) => {
        this.setState({ openRepresentativeModal: true, selectedRepId: dataItem.representative_id, selectedRepName:dataItem.representative_name})
    }

    handleSortClick = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleSortClose = (selectedSort = null) => {
        this.setState({
            anchorEl: null,
            selectedSort: selectedSort,
            sortBy: selectedSort?.sortBy
        }, () => {
            this.getRepDetails()
        })
    }

    handleSortDesc = () => {
        this.setState({
            sortBy: 'Representative Name',
            isSortByAsc: false,
            sortOrder: 'DESC'
        }, () => {
            this.getRepDetails();
        })
    }

    handleSortAsc = () => {
        this.setState({
            sortBy: 'Representative Name',
            isSortByAsc: true,
            sortOrder: 'ASC'
        }, () => {
            this.getRepDetails();
        })
    }

    render() {
        return (
            <MDBContainer fluid className="searchRepresentativeContainer">
                <MDBRow>
                    <MDBCol>
                        <span className="searchRepHeading">
                            {'Search Representatives'}
                        </span>
                    </MDBCol>
                    {this.props?.userContext?.user_profile?.role_name === 'Admin' &&
                        <MDBCol className="rep-profile-btn">
                            <BasicButton
                                variant="contained"
                                type="inline"
                                className="outlined-btn"
                                icon={"plus-circle"}
                                text="New Rep. Profile"
                                onClick={() => this.setState({ openRepresentativeModal: true, selectedRepId: null,selectedRepName:null })}
                            />
                        </MDBCol>
                    }
                </MDBRow>
                <MDBRow>
                    <span className="helper-text">
                        Search for Representative profiles. To add a filter, either select a value, or type in a field below and click ENTER.
                    </span>
                </MDBRow>
                <MDBRow className="search-filters">
                    <SearchFilters
                        isRepresentative={true}
                        handleFilterOnChange={this.handleFilterOnChange}
                        getEntitySearch={this.getEntitySearch}
                        handleSetClearFilter={this.handleSetClearFilter}
                        companyTypeOptions={this.state.companyTypeOptions}
                        repTypeOptions={this.state.repTypeOptions}
                        companyOptions={this.state.companyOptions}
                        coveredTalentOptions={this.state.coveredTalentOptions}
                        clearFilter={this.state.clearFilter}
                        deletedFilter={this.state.deletedFilter}
                    />
                </MDBRow>
                <MDBRow>
                    <MDBCol>
                        <MDBRow className="repTableContainer">
                            <MDBCol md={8} className="margin-right">
                                {this.state.repFilters?.length > 0 ?
                                    <div className="filter-section">
                                        <div>
                                            {this.state.repFilters?.map((item, index) => (
                                                <Chip
                                                    label={item?.value}
                                                    onDelete={() => this.handleFilterDelete(index, item?.filter)}
                                                />
                                            ))}
                                        </div>
                                        <div className="clear-criteria-btn">
                                            <BasicButton
                                                variant="outlined"
                                                text="Clear Filters"
                                                type="inline"
                                                onClick={this.handleClearCriteria}
                                            />
                                        </div>
                                    </div> : <p className="no-filters">No Filters added</p>
                                }
                            </MDBCol>
                            <MDBCol md={3}>
                                <div className="filter-section sort-section">
                                    <span className="sort-by-label">Sort By:</span>
                                    <div className="sort-by-menu">
                                        <Button
                                            aria-controls="sort-menu"
                                            aria-haspopup="true"
                                            onClick={this.handleSortClick}
                                            endIcon={<MDBIcon icon="chevron-right" />}
                                        >
                                            {this.state.selectedSort?.label || ''}
                                        </Button>
                                        <Menu
                                            id="sort-menu"
                                            anchorEl={this.state.anchorEl}
                                            keepMounted
                                            open={Boolean(this.state.anchorEl)}
                                            onClose={() => this.handleSortClose(this.state.selectedSort)}
                                        >
                                            {repSortByConfig?.map(item => (
                                                <MenuItem onClick={() => this.handleSortClose(item)}>
                                                    {item?.label}
                                                </MenuItem>

                                            ))}
                                        </Menu>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol>
                                {this.state.sortOrder === 'ASC' ?
                                    <MDBIcon fas icon="sort-alpha-down" onClick={this.handleSortDesc} /> :
                                    <MDBIcon fas icon="sort-alpha-up" onClick={this.handleSortAsc} /> 
                                }
                            </MDBCol>
                            <div className="search-rep-table">
                                <TableComponent
                                    list={this.state.list || []}
                                    isLoading={this.state.isFetchingRepList}
                                    config={this.state.config}
                                    hyperLinkNavigationCallback={this.navigationCallback}
                                />
                            </div>
                            <TablePagination
                                component="div"
                                count={this.state.repCount}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                page={this.state.page}
                                onChangePage={(e, page) => {
                                    this.setJson('page', page)
                                }}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={(e) => {
                                    this.setJson('pagePerRow', e.target.value)
                                }}
                            />
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
                {
                    this.state.openRepresentativeModal &&
                    <ModalComponent
                        navFuns={this.functions}
                        open={this.state.openRepresentativeModal}
                        handleClose={this.functions.handleHideRepPopup}
                        tabList={representativeAnimationList}
                        headerText={"Representatives"}
                        objectType={'REPRESENTATIVE'}
                        mode={"New"}
                        repId={this.state.selectedRepId}
                        toggleRefresh={this.getRepDetails}
                        selectedRepName={this.state.selectedRepName}
                    />
                }
            </MDBContainer >
        )
    }
}

export default withRouter(withUserContext(SearchRepresentativeContainer));